<script setup lang="ts">
import FeaturedIncidentsGrid from '../components/FeaturedIncidentsGrid.vue'
</script>

<template>
  <q-page padding>
    <div class="row q-mb-md">
      <div class="col-12">
        <h4 class="text-h4 text-weight-bold q-my-none text-blue-grey-9">Featured Incidents</h4>
      </div>
    </div>
    <featured-incidents-grid />
  </q-page>
</template>
